/* ==========================================================================
   BELORA - UNIVERSAL BEDEN SISTEMI (2026-09-04)
   --------------------------------------------------------------------------
   0 SABIT URUN ADI. Veri kaynagi: `[data-ws-size-config]` script tag'i,
   Liquid tarafindan urunun KENDI metafield'larindan basilir:
     mode              'legacy_model' | 'range'
     shopifySizesRaw   "XXS|XS|S|..." (urunun GERCEK Shopify beden degerleri)
     inputs            ['height','weight',...] (range modunda sorulacak olcu)
     profiles          urunun HAM size_profiles JSON'u (dogrulanmamis)

   ⚠️ SHOPIFY VARYANTI NIHAI OTORITEDIR. Bir profil satiri, etiketi
   `shopifySizesRaw` icinde YOKSA GECERSIZ sayilir - ne Beden Rehberi'nde
   gorunur ne Bedenimi Bul tarafindan onerilebilir. Bozuk/eksik satir
   (label'i olmayan) sessizce ATLANIR, sayfa CRASH ETMEZ.

   ⚠️ LEGACY MODEL (Korse) BU DOSYADA YENIDEN UYGULANMAZ. `mode ===
   'legacy_model'` oldugunda oneri hesaplamasi HALA `assets/ws-size.js`
   (556-kayitlik deterministik model, DEGISTIRILMEDI) tarafindan yapilir;
   bu dosya YALNIZ o modun REHBER TABLOSUNU (weight_by_height alanindan)
   render eder - ayni gorsel cikti, artik urun verisinden okunuyor.
   ========================================================================== */
(function () {
  'use strict';

  var MEASURE_LABELS = { height: 'Boy (cm)', weight: 'Kilo (kg)', waist: 'Bel (cm)', hip: 'Kalça (cm)' };
  var MEASURE_RANGE = { height: { min: 130, max: 210 }, weight: { min: 30, max: 180 }, waist: { min: 40, max: 160 }, hip: { min: 50, max: 180 } };
  var GUIDE_COL_LABEL = { height: 'Boy', weight: 'Kilo', waist: 'Bel', hip: 'Kalça' };

  function readConfig(root) {
    var tag = (root || document).querySelector('[data-ws-size-config]');
    if (!tag) return null;
    var cfg;
    try { cfg = JSON.parse(tag.textContent); } catch (e) { return null; }
    var shopifySizes = String(cfg.shopifySizesRaw || '').split('|').filter(function (s) { return s; });
    var rawProfiles = Array.isArray(cfg.profiles) ? cfg.profiles : [];
    /* GECERLI satirlar: label var VE Shopify'in gercek beden listesinde. */
    var validProfiles = rawProfiles.filter(function (row) {
      return row && typeof row.label === 'string' && row.label && shopifySizes.indexOf(row.label) > -1;
    });
    return { mode: cfg.mode || 'range', shopifySizes: shopifySizes, inputs: Array.isArray(cfg.inputs) ? cfg.inputs : [], profiles: validProfiles };
  }

  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }

  /* ------------------------------------------------------------ BEDEN REHBERI */
  function buildGuide(table, cfg) {
    if (!table || !cfg || !cfg.profiles.length) return false;
    var thead = table.querySelector('thead tr');
    var tbody = table.querySelector('tbody');
    thead.innerHTML = '<th scope="col">Beden</th>';
    tbody.innerHTML = '';

    var hasLegacy = cfg.profiles.some(function (r) { return r.weight_by_height && typeof r.weight_by_height === 'object'; });

    if (hasLegacy) {
      /* ESKI GORUNUM (Korse): boy basliklari + kilo araligi hucreleri. */
      var heights = Object.keys(cfg.profiles[0].weight_by_height || {}).sort(function (a, b) { return Number(a) - Number(b); });
      heights.forEach(function (h) {
        var th = document.createElement('th'); th.scope = 'col'; th.textContent = h + ' cm'; thead.appendChild(th);
      });
      cfg.profiles.forEach(function (row) {
        var tr = document.createElement('tr');
        var th = document.createElement('th'); th.scope = 'row'; th.textContent = row.label; tr.appendChild(th);
        heights.forEach(function (h) {
          var r = (row.weight_by_height || {})[h] || {};
          var td = document.createElement('td');
          td.textContent = fmtRange(r.min, r.max);
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      return true;
    }

    /* UNIVERSAL GORUNUM: yalniz VERI TASIYAN olcu sutunlari basilir. */
    var cols = ['height', 'weight', 'waist', 'hip'].filter(function (key) {
      return cfg.profiles.some(function (r) { return r[key + '_min'] != null || r[key + '_max'] != null; });
    });
    if (!cols.length) return false;
    cols.forEach(function (key) {
      var th = document.createElement('th'); th.scope = 'col'; th.textContent = GUIDE_COL_LABEL[key]; thead.appendChild(th);
    });
    cfg.profiles.forEach(function (row) {
      var tr = document.createElement('tr');
      var th = document.createElement('th'); th.scope = 'row'; th.textContent = row.label; tr.appendChild(th);
      cols.forEach(function (key) {
        var td = document.createElement('td');
        var lo = row[key + '_min'], hi = row[key + '_max'];
        td.textContent = (lo == null && hi == null) ? '—' : fmtRange(lo, hi);
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    return true;
  }

  function fmtRange(min, max) {
    if (min == null && max == null) return '—';
    if (min == null) return '≤ ' + max;
    if (max == null) return '≥ ' + min;
    return min + '–' + max;
  }

  /* ------------------------------------------------------------ BEDENIMI BUL (range) */
  function buildFinderFields(box, cfg) {
    var wrap = box.querySelector('[data-ws-universal-fields]');
    if (!wrap) return;
    wrap.innerHTML = '';
    var inputs = cfg.inputs.length ? cfg.inputs : ['height', 'weight'];
    inputs.forEach(function (key) {
      if (!MEASURE_LABELS[key]) return; /* taninmayan olcu turu sessizce atlanir */
      var label = document.createElement('label');
      label.className = 'ws-sf__field';
      label.innerHTML = '<span>' + MEASURE_LABELS[key] + '</span>';
      var input = document.createElement('input');
      input.type = 'number'; input.inputMode = 'numeric'; input.step = '1'; input.required = true;
      input.autocomplete = 'off';
      input.setAttribute('data-ws-u', key);
      var r = MEASURE_RANGE[key];
      input.min = r.min; input.max = r.max;
      label.appendChild(input);
      wrap.appendChild(label);
    });
  }

  /* Deterministik, aciklanabilir skor: her girilen olcu icin satirin
     [min,max] araliginin DISINDA kalinan mesafe toplanir (icerideyse 0).
     Alan urunde tanimli DEGILSE o olcu o satir icin YOK SAYILIR - ceza
     eklenmez (satiri haksiz yere elemez). */
  function scoreRow(row, values) {
    var total = 0, matchedAny = false;
    for (var key in values) {
      var v = values[key];
      if (v == null) continue;
      var lo = row[key + '_min'], hi = row[key + '_max'];
      if (lo == null && hi == null) continue; /* bu urun bu olcuyu kullanmiyor */
      matchedAny = true;
      if (lo != null && v < lo) total += (lo - v);
      else if (hi != null && v > hi) total += (v - hi);
    }
    return matchedAny ? total : null; /* null = bu satir icin hicbir ilgili veri yok */
  }

  function recommend(cfg, values) {
    var scored = cfg.profiles.map(function (row) { return { row: row, score: scoreRow(row, values) }; })
      .filter(function (s) { return s.score !== null; });
    if (!scored.length) return { ok: false, reason: 'no-data' };
    scored.sort(function (a, b) { return a.score - b.score; });
    var best = scored[0];
    /* Sinir durumu - AÇIK ve SABIT bir esikle: iki beden de TAM uyuyorsa
       (ikisinin de skoru 0, yani girilen olculer her iki araligin da
       icinde) VEYA en iyi ikisi birbirine 2 birim (cm/kg) veya daha az
       mesafedeyse KESIN bir beden ZORLANMAZ - musteriye ikisi de sunulur. */
    var second = scored[1];
    var borderline = null;
    if (second) {
      if (best.score === 0 && second.score === 0) borderline = second.row.label;
      else if (second.score - best.score <= 2) borderline = second.row.label;
    }
    return { ok: true, label: best.row.label, score: best.score, borderline: borderline };
  }

  /* ------------------------------------------------------------ finder radio esleme */
  function findRadio(sizeLabel) {
    var labels = document.querySelectorAll('.ws-opt__values label.ws-opt__chip');
    for (var i = 0; i < labels.length; i++) {
      var full = labels[i].getAttribute('data-value') || labels[i].textContent.trim();
      if (full === sizeLabel) {
        var input = document.getElementById(labels[i].getAttribute('for'));
        if (input && !input.disabled) return input;
        return null;
      }
    }
    return null;
  }

  function initFinder(box, cfg) {
    if (cfg.mode === 'legacy_model') return; /* ws-size.js zaten yonetiyor */
    if (box.__wsUniversalFinder) return;
    box.__wsUniversalFinder = true;

    buildFinderFields(box, cfg);

    var form = box.querySelector('[data-ws-universal-form]');
    var out = box.querySelector('[data-ws-result]');
    var err = box.querySelector('[data-ws-error]');
    if (!form || !out) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var values = {}, invalid = false;
      form.querySelectorAll('[data-ws-u]').forEach(function (input) {
        var key = input.getAttribute('data-ws-u');
        var v = num(input.value);
        var r = MEASURE_RANGE[key];
        if (v == null || v < r.min || v > r.max) invalid = true;
        values[key] = v;
      });
      if (invalid) {
        out.hidden = true; out.innerHTML = '';
        if (err) { err.textContent = 'Lütfen geçerli ölçüler girin.'; err.hidden = false; }
        return;
      }
      if (err) { err.hidden = true; err.textContent = ''; }

      var r = recommend(cfg, values);
      if (!r.ok) {
        out.innerHTML = '<p class="ws-sf__label">Bu ölçüler için net bir beden önerisi oluşturamadık.</p>' +
          '<p class="ws-sf__why">Beden Rehberi’ni kontrol edebilirsin.</p>';
        out.hidden = false; out.setAttribute('role', 'status');
        return;
      }

      var html = '<p class="ws-sf__label">Sana önerdiğimiz beden</p><p class="ws-sf__size">' + escapeHtml(r.label) + '</p>';
      if (r.borderline) {
        html += '<p class="ws-sf__note">Ölçünüz iki beden sınırına çok yakın. Daha sıkı bir tutuş istiyorsan küçük bedeni, ' +
          'daha rahat bir kullanım istiyorsan ' + escapeHtml(r.borderline) + ' bedenini seçebilirsin.</p>';
      }
      var radio = findRadio(r.label);
      if (radio) {
        html += '<button type="button" class="ws-btn ws-sf__apply" data-ws-apply="' + escapeAttr(r.label) + '">Bu bedeni seç</button>';
      }
      out.innerHTML = html; out.hidden = false; out.setAttribute('role', 'status');
    });

    form.addEventListener('reset', function () { out.hidden = true; out.innerHTML = ''; if (err) err.hidden = true; });

    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ws-apply]');
      if (!b) return;
      var radio = findRadio(b.getAttribute('data-ws-apply'));
      if (!radio) return;
      radio.click(); /* MUTASYON SAHIPLIGI: yalniz gercek radio tiklanir, gerisi variant-picker zinciridir */
      if (window.WSCore && window.WSCore.closePanel) window.WSCore.closePanel();
    });
  }

  function escapeHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function escapeAttr(s) { return escapeHtml(s).replace(/"/g, '&quot;'); }

  function boot(root) {
    var cfg = readConfig(root);
    if (!cfg) return;
    var table = (root || document).querySelector('#ws-sg-table');
    if (table && !table.__wsBuilt) { table.__wsBuilt = true; buildGuide(table, cfg); }
    var finderBox = (root || document).querySelector('[data-ws-sizefinder]');
    if (finderBox) initFinder(finderBox, cfg);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
